// extracted by mini-css-extract-plugin
export default {"snackbarMessage":"src-client-components-Snackbars-components-SnackbarMessage-___default__snackbarMessage___blXx8"};